import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { formatMoney, displayDate } from '@iso/lib/helpers/utility';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        fontSize: 7,
        width: '100%',
        // minHeight: 40,
        fontStyle: 'bold',
        flexDirection: 'row',
        alignItems: 'center',
        // borderBottomWidth: 1,
        // borderBottomColor: '#000000'
    },
    collumn: {
        padding: 2,
        textAlign: 'left',
        // borderRightWidth: 1,
        // borderRightColor: borderColor
    },
});

const MovimentsTableRow = ({ items }) => {

    let dueDate, document, paymentDate, history, value, clientName, accountPlanName, costCenterName, saldo, type, bankAccountName;

    return (
        <Fragment>
            {items.map((item, i) => {
                type = (item?.type) ? item.type : '';
                saldo = (item?.saldo) ? item.saldo : 0;
                dueDate = (item?.dueDate) ? item.dueDate : 0;
                document = (item?.document) ? item.document : 0;
                history = (item?.history) ? item.history : '';
                value = (item?.payment.value) ? item.payment.value : 0;
                paymentDate = (item?.payment.date) ? item.payment.date : '';
                clientName = (item?.clientName) ? item.clientName : '';
                costCenterName = (item?.costCenterName) ? item.costCenterName : '';
                accountPlanName = (item?.accountPlanName) ? item.accountPlanName : '';
                bankAccountName = (item?.payment.bankAccountName) ? item.payment.bankAccountName : '';

                return (
                    <View style={{...styles.row, ...{ backgroundColor: (i % 2 === 0 ? '#f2f2f2': '#FFF') }}} key={(item?.item?._id) ? item?.item?._id : 0} wrap={false}>
                        <Text style={{ ...styles.collumn, ...{width:'7%', textAlign: 'center'} }}>{displayDate(dueDate)}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'7%', textAlign: 'center'} }}>{paymentDate}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'7%'} }}>{document}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'12%'} }}>{clientName}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'21%'} }}>{history}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'10%'} }}>{bankAccountName}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'10%'} }}>{accountPlanName}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'10%'} }}>{costCenterName}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'7%', textAlign: 'right', color: (type === 'Receber') ? 'blue' : 'red'} }}>{formatMoney(value + '')}</Text>
                        <Text style={{ ...styles.collumn, ...{width:'9%', textAlign: 'right', borderRightWidth:0} }}>{formatMoney(saldo+'')}</Text>
                    </View>
                )
            })}
        </Fragment>)
};

export default MovimentsTableRow